<template>
  <div class="typing-indicator"></div>
</template>

<script>
export default {}
</script>

<style scoped>
.typing-indicator {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  animation: typingIndicator 0.5s infinite linear alternate;
  animation-delay: 0.25s;
}

.typing-indicator::before,
.typing-indicator::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

.typing-indicator::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  animation: typingIndicator 0.5s infinite alternate;
  animation-delay: 0s;
}

.typing-indicator::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  animation: typingIndicator 0.5s infinite alternate;
  animation-delay: 0.5s;
}

@keyframes typingIndicator {
  0% {
    background-color: #979797;
  }
  50%,
  100% {
    background-color: #97979769;
  }
}
</style>
